import React from 'react'
import { Link } from 'react-router-dom'

export const HeaderLogo = () => {

	const logo = require('../images/econobit-white.svg')

	return (
		<div className='headerLogo'>
			<Link to='/'>
				<img src={logo} className='header-logo' alt='logo' />
			</Link>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/headerLogo.tsx